import type { ReactNode } from "react";
import { localizeDigits, useStoreLanguage } from "../../../features/store-language/i18n.ts";
import "./account-document-header.css";

type DocumentFact = {
  key: string;
  label: string;
  value: string;
  control?: ReactNode;
  direction?: "ltr" | "rtl";
};

/** Compact document identity with optional authorized controls supplied by the feature. */
export default function AccountDocumentHeader({ children, metadata, className = "" }: {
  children: ReactNode;
  metadata?: readonly DocumentFact[];
  className?: string;
}) {
  useStoreLanguage();
  return (
    <div className={`account-document-header ${className}`}>
      <div className="account-document-header__title">
        {children}
      </div>
      {metadata?.length ? (
        <dl className="account-document-header__metadata">
          {metadata.map(function (fact) {
            return (
              <div
                key={fact.key}
                className={"account-document-header__fact" + (fact.control ? " has-control" : "")}
              >
                <dt>{fact.label}</dt>
                <dd>
                  {fact.control ?? <bdi dir={fact.direction}>{localizeDigits(fact.value) || "—"}</bdi>}
                </dd>
              </div>
            );
          })}
        </dl>
      ) : null}
    </div>
  );
}
